import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import type { IBlockUserByIdRequest, IUnblockUserByIdRequest } from "./request.types";
import type { TGetBlackListResponse } from "./response.types";

class BlacklistController extends Controller {
	public constructor() {
		super({ requestUrl: "models/black_list" });
	}

	/**@GET BLACK LIST */
	public async getBlackListAsync({ token }: IRequestConfig) {
		return this.get<TGetBlackListResponse[]>("base", "", { token });
	}

	/**@POST BLOCK USER BY ID */
	public async blockUserByIdAsync({ token, id, reason, term }: IBlockUserByIdRequest) {
		return this.post<{ code: number; message: string }>(
			"",
			{
				userId: id,
				reason: reason,
				term: term,
			},
			{ token },
		);
	}

	/**@DELETE UNBLOCK USER BY ID */
	public async unBlockUserByIdAsync({ token, userId }: IUnblockUserByIdRequest) {
		return this.delete<{ code: number; message: string }>("", { data: { userId }, token });
	}
}

export const blacklistAPI = new BlacklistController();
